/**
 * Sticky Cards: like CodePen WNYKage – cards stick with increasing top offset;
 * as the next card scrolls over, the current card scales down by 10% per card on top.
 * Scale is driven by next card's scroll position (scrub).
 */
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const SCALE_STEP = 0.1; // 10% smaller per card stacked on top

function getStickyTopPx(index) {
	const base = typeof getComputedStyle !== "undefined"
		 ? parseFloat(getComputedStyle(document.documentElement).fontSize) * 1.5 || 24
		 : 24;
	return base + index * 24;
}

export function initStickyCards() {
	const section = document.querySelector(".sticky-cards");
	if (!section) return;

	const wrappers = section.querySelectorAll(".sticky-cards__card-wrapper");
	if (!wrappers.length) return;

	const cards = section.querySelectorAll(".sticky-cards__card");
	wrappers.forEach((wrapper, index) => {
		const card = wrapper.querySelector(".sticky-cards__card");
		const inner = wrapper.querySelector(".sticky-cards__card-inner");
		if (!card || !inner) return;

		// Last card stays at scale 1
		if (index === cards.length - 1) return;

		// toScale = 1 - (number of cards that will stack on top) * 0.1
		const toScale = 1 - (cards.length - 1 - index) * SCALE_STEP;
		const nextWrapper = wrappers[index + 1];
		if (!nextWrapper) return;

		const nextStickyTop = getStickyTopPx(index + 1);
		const startY = `${nextStickyTop}px`;
		// Scrub from when next card hits its sticky top until next card leaves viewport (like CodePen)
		gsap.fromTo(
			inner,
			{ scale: 1 },
			{
				scale: toScale,
				ease: "none",
				scrollTrigger: {
					trigger: nextWrapper,
					start: `top ${startY}`,
					end: "bottom top",
					scrub: 0.3,
					invalidatesOnRefresh: true,
				},
			}
		);
	});
}
